<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">İletişim</p>
    <h1 class="h1" style="margin-top:16px">Yazın, aynı gün dönelim.</h1>
    <p class="giris-p">Kurum demosu, öğretmen desteği ya da bir hata bildirimi — hepsi aynı kutuya düşüyor ve hafta içi 24 saat içinde yanıtlıyoruz.</p>
  </div>
</div>

<div class="sar bol">
  <div class="g2" style="gap:44px;align-items:start">
    <form (ngSubmit)="gonder()">
      <h3 class="h3" style="margin-bottom:18px">Mesaj bırakın</h3>
      <div class="g2" style="gap:14px">
        <div class="alan"><label for="i-ad">Ad soyad</label><input id="i-ad" name="ad" [(ngModel)]="ad" placeholder="Elif Demir" required></div>
        <div class="alan"><label for="i-mail">E-posta</label><input id="i-mail" name="mail" type="email" [(ngModel)]="mail" placeholder="ad@okulunuz.k12.tr" required></div>
      </div>
      <div class="alan">
        <label for="i-konu">Konu</label>
        <select id="i-konu" name="konu" [(ngModel)]="konu">
          <option>Kurum demosu istiyorum</option>
          <option>Öğretmen olarak kullanmak istiyorum</option>
          <option>Kurumsal firma çözümü</option>
          <option>Teknik destek</option>
          <option>Diğer</option>
        </select>
      </div>
      <div class="alan"><label for="i-mesaj">Mesaj</label><textarea id="i-mesaj" name="mesaj" rows="5" [(ngModel)]="mesaj" placeholder="Kurumunuzu, sınıf sayınızı ve beklentinizi kısaca yazın."></textarea></div>
      <button class="btn kirmizi" type="submit">Mesajı gönder <svg><use xlink:href="#i-ok"></use></svg></button>
      <p class="soluk" style="font-size:12.5px;margin-top:12px">Formu göndererek KVKK aydınlatma metnini okuduğunuzu kabul edersiniz.</p>
    </form>
    <div>
      <div class="kart" style="padding:22px">
        <span class="etiket">Doğrudan</span>
        <a href="mailto:help@pratiu.com" style="display:flex;align-items:center;gap:10px;margin-top:12px;font-family:var(--f-d);font-weight:700;font-size:21px;letter-spacing:-.02em;color:var(--mor)">
          <svg style="width:19px;height:19px"><use xlink:href="#i-mail"></use></svg> help@pratiu.com
        </a>
        <p class="soluk" style="font-size:14px;margin-top:10px">Hafta içi 09:00–18:00 arası yanıtlıyoruz.</p>
      </div>
      <div class="kart" style="padding:22px;margin-top:18px">
        <span class="etiket">Sık gelen sorular</span>
        <ul class="tik" style="margin-top:14px">
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Deneme sürümü var mı?</b> Bireysel öğretmenler için ücretsiz plan var.</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Veli hesabı zorunlu mu?</b> Hayır, öğretmen açmadıkça veli erişimi kapalıdır.</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Kendi sorularımı yükleyebilir miyim?</b> Evet, görselli sorular dâhil.</span></li>
        </ul>
      </div>
    </div>
  </div>
</div>
